import React from 'react';
import { connect } from 'react-redux';
import '../../style/FloatingCard.css';
import CustomModal from '../layout/CustomModal';
import {
	flexDirection
} from '../../style/Global';
import { useMediaQuery } from 'react-responsive';
import {
	device
} from '../../style/breakpoints';


function ModalFirstTimeVisit({closeModalFirstTimeVisit}) {
	const isTabletOrMobile = useMediaQuery({ query: device.tablet });

	const headerStyle = isTabletOrMobile ?
		{
			fontWeight: 'bold',
			fontSize: '2rem'
		} :
		{
			fontWeight: 'bold',
			fontSize: '3rem'
		}
	const subHeaderStyle = isTabletOrMobile ?
		{
			fontWeight: 'bold',
            fontSize: '1rem',
            color:'rgb(0, 126, 167)'
		} :
		{
			fontWeight: 'bold',
            fontSize: '2rem',
            color:'rgb(0, 126, 167)'
		}

	const modalStyle = isTabletOrMobile ?
		{
			height:'100%',
			margin: '5px',
			marginTop:'15px !important'
		} :
		{
			width: '70%',
			height: '40%'
		}

	return (
		<CustomModal
			closeModal={closeModalFirstTimeVisit}
			modalTitle='What is ANTHEMS OF THE WORLD about?'
			modalStyle={modalStyle}
			modalBody={
				<div
					style={{...flexDirection.column, height:'100%', overflowY:'auto',position:'absolute'}}
				>
					<p

						style={subHeaderStyle}
					>


                        As the name suggests, in this website you can listen to the anthems of all countries of the world. 
                        Select a country and enjoy!
					</p>				
				
				</div>
			}
		/>
	);

}


// export default connect(mapStateToProps, mapDispatchToProps)(ModalFirstTimeVisit);

export default ModalFirstTimeVisit;